import { useSyncExternalStore } from 'react'

// Module-level: the region is mounted once by ContentPanelArea, while the
// events that need announcing happen inside TabBar. A store this small does
// not earn a zustand slice.
const EMPTY = { text: '', seq: 0 }
let state = EMPTY
const subscribers = new Set<() => void>()

/** Announces a shelf change (tab closed, …) to assistive tech. */
export function announce(next: string) {
  state = { text: next, seq: state.seq + 1 }
  for (const notify of subscribers) notify()
}

function subscribe(notify: () => void) {
  subscribers.add(notify)
  return () => {
    subscribers.delete(notify)
  }
}

const getSnapshot = () => state
const getServerSnapshot = () => EMPTY

/**
 * Polite live region for the tab shelf. Mounted once, outside the tab trees,
 * so it is already registered with assistive tech before the first message —
 * a region that appears together with its text is not announced.
 */
export function ShelfAnnouncer() {
  const { text, seq } = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot
  )
  return (
    <div role="status" aria-live="polite" className="sr-only">
      {/* Two identical messages in a row must both be announced, and an
          unchanged text node is not. The invisible trailing space on odd
          sequence numbers makes every announce() mutate the region. */}
      {seq % 2 === 1 ? `${text} ` : text}
    </div>
  )
}
